import apiFetch from "../../../shared/services/apiClient";
import i18n from "../../../shared/i18n/i18n";

async function json(res) {
  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    const err = new Error(data.detail || "No se pudo completar la acción.");
    err.status = res.status;
    err.data = data;
    throw err;
  }
  return data;
}

const q = (params) => {
  const u = new URLSearchParams();
  Object.entries(params || {}).forEach(([k, v]) => {
    if (v !== undefined && v !== null && v !== "") u.set(k, v);
  });
  const s = u.toString();
  return s ? `?${s}` : "";
};

// ── Casas y personas ─────────────────────────────────────────────────────
export const buscarCasas   = (texto) => apiFetch(`/api/seguridad/casas/${q({ q: texto })}`).then(json);
export const listaCasas    = () => apiFetch("/api/seguridad/casas/?lista=1").then(json);
export const obtenerCasa   = (id) => apiFetch(`/api/seguridad/casas/${id}/`).then(json);
export const buscarPersona = (params) => apiFetch(`/api/seguridad/buscar-persona/${q(params)}`).then(json);

// ── Registros de acceso ──────────────────────────────────────────────────
export const listarRegistros = (params) => apiFetch(`/api/seguridad/registros/${q(params)}`).then(json);
export const registrarIngreso = (data) =>
  apiFetch("/api/seguridad/registros/", { method: "POST", body: JSON.stringify(data) }).then(json);
export const marcarSalida = (id) =>
  apiFetch(`/api/seguridad/registros/${id}/salida/`, { method: "POST" }).then(json);

// ── Guardas del condominio ───────────────────────────────────────────────
export const listarGuardas = () => apiFetch("/api/seguridad/guardas/").then(json);
export const crearGuarda = (data) =>
  apiFetch("/api/seguridad/guardas/", { method: "POST", body: JSON.stringify(data) }).then(json);
export const editarGuarda = (id, data) =>
  apiFetch(`/api/seguridad/guardas/${id}/`, { method: "PATCH", body: JSON.stringify(data) }).then(json);
export const quitarGuarda = (id) =>
  apiFetch(`/api/seguridad/guardas/${id}/`, { method: "DELETE" }).then((res) => {
    if (!res.ok) return json(res);
    return null;
  });

// ── Textos (español / inglés) ────────────────────────────────────────────
// Los códigos vienen del backend; el texto se elige acá según el idioma.
export const MOTIVOS = [
  { value: "VISITA",   es: "Visita",     en: "Visit",       icon: "fa-user-group" },
  { value: "ENTREGA",  es: "Entrega",    en: "Delivery",    icon: "fa-box" },
  { value: "SERVICIO", es: "Servicio",   en: "Service",     icon: "fa-screwdriver-wrench" },
  { value: "TAXI",     es: "Taxi / app", en: "Taxi / ride", icon: "fa-taxi" },
  { value: "OTRO",     es: "Otro",       en: "Other",       icon: "fa-ellipsis" },
];

const TEXTOS = {
  VEHICULAR:     ["Vehicular", "Vehicle"],
  PEATONAL:      ["Peatonal", "On foot"],
  VISITA:        ["Visita", "Visitor"],
  PROPIETARIO:   ["Propietario", "Owner"],
  COPROPIETARIO: ["Copropietario", "Co-owner"],
  AUTORIZADO:    ["Autorizado", "Authorized"],
  RESIDENTE:     ["Ingreso de residente", "Resident entry"],
  Familiar:      ["Familiar", "Family"],
  Inquilino:     ["Inquilino", "Tenant"],
  Empleado:      ["Empleado", "Employee"],
  ...Object.fromEntries(MOTIVOS.map((m) => [`MOTIVO_${m.value}`, [m.es, m.en]])),
};

const esIngles = () => i18n.language === "en";

/** Texto de un código (tipo, categoría, relación) en el idioma activo. */
export function texto(codigo) {
  const t = TEXTOS[codigo];
  return t ? t[esIngles() ? 1 : 0] : codigo;
}

export function textoMotivo(codigo) {
  if (codigo === "RESIDENTE") return texto("RESIDENTE");
  return texto(`MOTIVO_${codigo}`);
}

// ── Formato ──────────────────────────────────────────────────────────────
const locale = () => (esIngles() ? "en-US" : "es-CR");

export function hora(iso) {
  if (!iso) return "-";
  return new Date(iso).toLocaleTimeString(locale(), { hour: "2-digit", minute: "2-digit" });
}

export function fechaHora(iso) {
  if (!iso) return "-";
  const d = new Date(iso);
  return `${d.toLocaleDateString(locale(), { day: "2-digit", month: "2-digit" })} ${hora(iso)}`;
}

/** "1 h 25 min" desde `desde` hasta `hasta` (o ahora). */
export function duracion(desde, hasta) {
  if (!desde) return "";
  const min = Math.max(0, Math.round(((hasta ? new Date(hasta) : new Date()) - new Date(desde)) / 60000));
  if (min < 60) return `${min} min`;
  return `${Math.floor(min / 60)} h ${String(min % 60).padStart(2, "0")} min`;
}
